import DynamicCards, { DynamicCardsProps } from "./DynamicCards";

export { DynamicCards , DynamicCardsProps };

export default DynamicCards;
